import axios from 'axios';
import { getToken, createApiUrl } from '../../../../util';
import api from 'api/axiosInstance';
import { FacetEditShadingStatus } from 'api/editDsm';

/**
 * `shadingStatus` is present only when the rotation left the shaded flux stale — an
 * NSRDB (in-house-simulation) ground-mount/flat facet, whose racks are baked into the
 * DSM. Pass it to useStartShadingRecalc to fire the background rebuild.
 */
type RotateFacetResponse = {
	panelsCount: number;
	shadingStatus?: FacetEditShadingStatus;
};

async function changeFacetOrientation(selectFacetId: string,
	uuid: string, panelKey: string, orientation: string, userMapped: boolean): Promise<RotateFacetResponse> {
	const token = getToken('Authorization');
	const config = {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	};

	const body = {
		selectedRoofSegmentId: selectFacetId,
		orientation,
		uuid,
		panelKey,
		userMapped
	};

	const apiUrl = '/designs/rotate-roof-segments';
	const { data } = await api.post(createApiUrl(apiUrl), body, config);
	return data;
}

export {
	changeFacetOrientation
};
export type { RotateFacetResponse };